import { NumberFormatter } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import cx from 'clsx';

import classes from '../Kpi.module.css';
import type { KpiSchemaInput } from '../schema.ts';

/**
 * Alert-style KPI rendering - colored gradient background with optional emergency styling.
 * Used when `color` and/or `kind` props are provided.
 */
export function AlertKpi({ value, label, unit, color, kind, decimalScale = 1 }: Omit<KpiSchemaInput, 'type'>) {
  const kindClass =
    typeof kind === 'string' && kind ? (classes as Record<string, string | undefined>)[kind] : undefined;
  const colorClass =
    typeof color === 'string' && color ? (classes as Record<string, string | undefined>)[color] : undefined;

  return (
    <div className={cx(classes.alert, kindClass, colorClass)}>
      {kind === 'emergency' && (
        <div className={classes.alertIcon}>
          <IconAlertTriangle size={32} />
        </div>
      )}
      <div className={classes.alertLabelContainer}>
        <div className={classes.alertLabel}>{label ?? 'Unknown metric'}</div>
        {unit !== undefined && <div className={classes.alertUnit}>{unit}</div>}
      </div>
      <div className={classes.alertValueContainer}>
        <div className={classes.alertValue}>
          {typeof value === 'number' ? (
            <NumberFormatter decimalScale={decimalScale} thousandSeparator value={value} />
          ) : (
            (value ?? 'n/a')
          )}
        </div>
      </div>
    </div>
  );
}
